import { track } from '@eventbrite/datalayer-library';
import { DiscoBall as DiscoBallSvg } from '@eventbrite/eds-iconography';
import { Typography } from '@eventbrite/marmalade';
import React from 'react';
import styles from './NLTouchpoint.module.scss';
import {
    BUTTONS_DATA,
    TITLE_DESKTOP,
    TITLE_MOBILE,
    TOUCHPOINT_DETAIL,
} from './touchpoint';

interface DetailsProps {
    isMobile: boolean;
}

interface ActionsProps {
    locationSlug?: string;
}

const calculateTopOffset = () => {
    let isMobile = false;
    if (typeof window !== 'undefined') {
        isMobile = window?.innerWidth <= 660;
    }
    return isMobile;
};

export const NLTouchpoint = (props: ActionsProps) => {
    const { locationSlug } = props;
    const isMobile = calculateTopOffset();

    return (
        <div className={styles.touchpointCardDiv}>
            <div className={styles.touchpoint}>
                <Details isMobile={isMobile} />
                <Actions locationSlug={locationSlug} />
            </div>
        </div>
    );
};

const Details = ({ isMobile }: DetailsProps) => {
    return (
        <div className={styles.details}>
            <div className={styles.icon}>
                <DiscoBallSvg />
            </div>
            <div className={styles.detailText}>
                <Typography variant="heading-sm" className={styles.title}>
                    {isMobile ? TITLE_MOBILE : TITLE_DESKTOP}
                </Typography>
                <Typography variant="body-md" className={styles.description}>
                    {TOUCHPOINT_DETAIL}
                </Typography>
            </div>
        </div>
    );
};

const Actions = ({ locationSlug }: ActionsProps) => {
    const handleOnClick = (subcategory: string) => {
        track({
            eventName: `NLTouchpointCityBrowse`,
            eventData: {
                category: subcategory,
            },
        });
    };

    return (
        <div className={styles.actions}>
            {BUTTONS_DATA.map((action, index) => (
                <a
                    className={styles.button}
                    key={index}
                    data-heap-id="NL-touchpoint-citybrowse"
                    onClick={() => handleOnClick(action.subcategory)}
                    href={`/b/${locationSlug}/nightlife/?category=${action.subcategory}`}
                >
                    <Typography variant="body-md-bold">
                        {action.title}
                    </Typography>
                </a>
            ))}
        </div>
    );
};
